import { useState } from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import ModePicker from "../../../../components/ModePicker";
import OccupantTypePicker from "../../../../components/OccupantTypePicker";
import FilterWarningPrompt from "./filterWarningPrompt";
import NitroModal from "../../../../components/Modal";

import "./index.css";
import ProductPicker from "../../../../components/ProductPicker";

const AdditionalFiltersModal = ({
  product,
  setProduct,
  mode,
  setMode,
  partyTypes,
  setPartyTypes,
  search,
  reset,
  clear,
  close,
  hasChange,
}: {
  product: string;
  setProduct: (value: string) => void;
  mode: string;
  setMode: (value: string) => void;
  partyTypes: string[];
  setPartyTypes: (value: string[]) => void;
  search: () => void;
  reset: () => void;
  clear: () => void;
  close: () => void;
  hasChange: boolean;
}) => {
  const [showWarning, setShowWarning] = useState(false);

  function closePrompt() {
    console.info("Close prompt", { hasChange });
    if (hasChange) {
      setShowWarning(true);
    } else {
      close();
    }
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(15, 44, 82, 0.5)",
          zIndex: 101,
        }}
      />
      <NitroModal
        className="additionalFiltersPanel"
        opaqueBackground
        open
        style={{
          zIndex: 102,
        }}
      >
        <ClickAwayListener onClickAway={() => closePrompt()}>
          <div
            className="additionalFiltersPanelBody"
            style={{
              display: showWarning ? "none" : "flex",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
                paddingBottom: 15,
                paddingTop: 15,
                borderBottom: "1px solid lightgray",
              }}
            >
              <div style={{ fontSize: 20, fontWeight: 500, color: "#0F2C52" }}>
                Filters
              </div>
            </div>

            {/* BODY */}
            <div
              style={{
                flexGrow: 1,
                // flexBasis: 0,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                padding: "15px 20px",
                gap: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div
                  style={{ fontSize: 20, fontWeight: 500, color: "#4b4b4b" }}
                >
                  Product
                </div>
                {/* <ProductFilter value={product} setValue={setProduct} /> */}
                <ProductPicker value={product} setValue={setProduct} />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div
                  style={{ fontSize: 20, fontWeight: 500, color: "#4b4b4b" }}
                >
                  Modes
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ModePicker value={mode} setValue={setMode} />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div
                  style={{ fontSize: 20, fontWeight: 500, color: "#4b4b4b" }}
                >
                  Occupant Types
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <OccupantTypePicker
                    values={partyTypes}
                    setValues={setPartyTypes}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                borderTop: "1px solid lightgray",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "15px 30px",
                // paddingBottom: 20,
              }}
            >
              <Button
                id="clearAdditionalFiltersButton"
                color="neutral"
                onClick={clear}
              >
                Clear
              </Button>

              <Button
                id="applyAdditionalFiltersButton"
                variant="contained"
                onClick={() => {
                  search();
                  // setShowFilters(false);
                  close();
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </ClickAwayListener>
      </NitroModal>

      {showWarning && (
        <FilterWarningPrompt
          discard={() => {
            reset();
            close();
          }}
          apply={() => {
            search();
            close();
          }}
        />
      )}
    </>
  );
};

export default AdditionalFiltersModal;
